declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export function pushDataLayerEvent(event: Record<string, unknown>): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

/** Ported from typ.html.twig: {'event':'formularze','wypelniony-formularz':'newsletter-zamowiono-{slug}'} */
export function pushSubscribeSuccessEvent(slug: string): void {
  pushDataLayerEvent({ event: 'formularze', 'wypelniony-formularz': `newsletter-zamowiono-${slug}` });
}
